import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
});

export const urlParamCharacter = process.env.NODE_ENV === 'development' ? '&' : '?';

export default api;
